import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { withRouter } from 'react-router';

import { currentCustomer, currentUser, duckify } from 'utils/duckify';
import Routes from '../../../routes';
import '../../../../stylesheets/components/flat_pill.scss';
import './styles/AdmissionWorkflowNavigation.scss';

const AdmissionWorkflowNavigation = ({
  customer,
  user,
  location
}) => (
  <ul className='admmission-workflow-navigation nav nav-pills flat-pill '>
    {customer.modules.includes('prospect_management') && (
      <li className={location.pathname === Routes.admissions_prospects_path() ? 'active' : ''}>
        <a href={Routes.admissions_prospects_path()}>
          Prospects
        </a>
      </li>
    )}
    {customer.modules.includes('inquiry_management') && (
      <li className={location.pathname === Routes.admissions_inquiries_path() ? 'active' : ''}>
        <a href={Routes.admissions_inquiries_path()}>
          Inquiries
        </a>
      </li>
    )}
    <li className={location.pathname === Routes.admissions_applicants_path() ? 'active' : ''}>
      <a href={Routes.admissions_applicants_path()}>
        Applicants
      </a>
    </li>
    {user.manage_review_permitted && (
      <li className={location.pathname === Routes.reviews_admin_path() ? 'active' : ''}>
        <a href={Routes.reviews_admin_path()}>
          Candidates In Review
        </a>
      </li>
    )}
    <li className={location.pathname === Routes.admissions_in_enrollment_path() ? 'active' : ''}>
      <a href={Routes.admissions_in_enrollment_path()}>
        Entering Enrollment
      </a>
    </li>
  </ul>
);

AdmissionWorkflowNavigation.propTypes = {
  /** Current Customer Duck */
  customer: PropTypes.shape({
    id: PropTypes.string,
    modules: PropTypes.arrayOf(
      PropTypes.string
    )
  }).isRequired,

  /** Current User Duck */
  user: PropTypes.shape({
    id: PropTypes.string,
    manage_review_permitted: PropTypes.bool
  }).isRequired,

  /** withRouter HOC Location prop */
  location: PropTypes.shape({
    pathname: PropTypes.string
  }).isRequired
};

const mapDucksToProps = () => ({
  customer: currentCustomer,
  user: currentUser
});

export default compose(
  duckify(mapDucksToProps),
  withRouter
)(AdmissionWorkflowNavigation);
